import { styled } from '@mui/system';
import { Paper, Box, Typography, Stack } from '@mui/material';
import { colors, fontFamilies } from '../../../../../constants/theme';

export const CardPaper = styled(Paper)(({ theme }) => ({
  bgcolor: '#FFFFFF',
  padding: '10px',
  width: '100%',
  maxWidth: '900px',
  [theme.breakpoints.up('md')]: {
    maxHeight: '230px',
  },
  [theme.breakpoints.down('md')]: {
    maxWidth: '100%',
  },
  borderRadius: '40px',
  boxShadow: '0px 0px 10px 0px rgba(0, 0, 0, 0.08)',
}));

export const CardStack = styled(Stack)(({ theme }) => ({
  padding: 0,
  height: '100%',
  alignItems: 'center',
}));

export const ImageContainer = styled(Box)(({ theme }) => ({
  backgroundColor: colors.iconBackground,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: '30px',
  [theme.breakpoints.up('lg')]: {
    minWidth: '320px',
    minHeight: '210px',
  },
  [theme.breakpoints.down('lg')]: {
    minWidth: '300px',
    minHeight: '190px',
  },
  [theme.breakpoints.down('md')]: {
    minWidth: '100%',
    minHeight: '160px',
  },
  [theme.breakpoints.down('sm')]: {
    minHeight: '140px',
  },
}));

export const CardImage = styled(Box)({
  width: 'auto',
});

export const ContentBox = styled(Box)(({ theme }) => ({
  textAlign: 'left',
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  gap: '20px',
  [theme.breakpoints.up('md')]: {
    marginLeft: '50px',
  },
  [theme.breakpoints.down('md')]: {
    textAlign: 'center',
    margin: '20px 20px',
    gap: '16px',
  },
  [theme.breakpoints.down('sm')]: {
    margin: '16px 12px',
    gap: '12px',
  },
}));

export const CardTitle = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'reverse',
})(({ theme }) => ({
  ...theme.typography.heading,
  fontSize: 32,
  lineHeight: '100%',
  letterSpacing: '-.3px',
  [theme.breakpoints.down('md')]: {
    fontSize: 18,
  },
}));

export const CardSubTitle = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'reverse',
})(({ theme }) => ({
  ...theme.typography.subtext,
}));

export const CardDescription = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'reverse',
})(({ theme }) => ({
  ...theme.typography.subtext,
  textAlign: 'left',
  fontSize: '20px',
  fontFamily: fontFamilies.quicksand,
  fontWeight: 400,
  whiteSpace: 'pre-line',
  [theme.breakpoints.down('md')]: {
    textAlign: 'center',
    fontSize: '16px',
  },
}));
